<!--
 * @Description:
 * @Author: cxh
 * @Date: 2022-08-25 15:30:18
 * @LastEditTime: 2022-08-25 15:30:18
 * @LastEditors: cxh
-->
<template>
  <div class="fix-footer">
    <div class="content">
      <slot></slot>
    </div>
    <div class="footer-layout">
      <template v-if="autoFooter">
        <div class="line-bg"></div>
        <div class="footer-btn">
          <slot name="footer"></slot>
        </div>
      </template>
      <slot name="footer" v-else></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  autoFooter: {
    type: Boolean,
    default: true
  }
})
</script>
<script lang="ts">
export default { name: 'fixFooterPage' }
</script>

<style lang="scss" scoped>
.fix-footer {
  flex: 1;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    overflow-y: auto;
  }
}
.footer-layout {
  width: 100%;
  background: #ffffff;
  position: sticky;
  bottom: 0;
  text-align: center;
  .footer-btn {
    padding: 17px;
  }
}
.line-bg {
  height: 8px;
  margin-left: -16px;
  margin-right: -16px;
  background-color: rgb(249, 249, 255);
  padding: 0 16px;
}
</style>
